import {SelectProps} from '@amzn/awsui-components-react/polaris/select';

export const regions: Array<SelectProps.Option> = [
    {label: 'NA', value: 'NA'},
    {label: 'EU', value: 'EU'},
    {label: 'FE', value: 'FE'},
]